var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"page-title"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),(_vm.links.length > 0)?_c('b-breadcrumb',{attrs:{"items":_vm.links}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }